// // src/components/StorageIcon.js

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//   IconButton,
//   Tooltip,
//   Box,
//   LinearProgress,
//   useMediaQuery,
// } from "@mui/material";
// import { FaHdd } from "react-icons/fa";
// import { GiSpades } from "react-icons/gi";
// import config from "../config";

// const baseUrl = config.baseURL;

// const StorageIcon = () => {
//   const [storageStats, setStorageStats] = useState(null);
//   const isMobile = useMediaQuery("(max-width:768px)");

//   // 💡 REMOVED: formatBytes helper function (since backend provides GB string)
//   const fetchStorageStats = async () => {
//     if (storageStats !== null) return;

//     const token = localStorage.getItem("token");
//     if (!token) return;

//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => controller.abort(), 10000);

//     try {
//       const response = await fetch(`${baseUrl}/api/storage`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         signal: controller.signal,
//       });

//       if (!response.ok) throw new Error("Failed");

//       const data = await response.json();
//       setStorageStats(data);
//     } catch {
//       setStorageStats("error");
//     } finally {
//       clearTimeout(timeoutId);
//     }
//   };

//   if (isMobile) {
//     return null;
//   }

//   // Parse usagePercentage as a number for the LinearProgress value
//   const usagePercentage = parseFloat(storageStats?.usage_percentage || 0);
//   const dataUsedGB = storageStats?.data_used_gb || "0.000";
//   const dataLimitGB = storageStats?.data_limit_gb || "0.000";

//   // Tooltip content for the hover effect
//   const tooltipContent = (
//     <Box sx={{ padding: 1, minWidth: 250 }}>
//       <h4 style={{ margin: "0 0 10px 0", color: "#F9FAFB", fontSize: "14px" }}>
//         Storage Usage
//       </h4>
//       {storageStats ? (
//         <>
//           {/* Progress Bar */}
//           <LinearProgress
//             variant="determinate"
//             value={usagePercentage} // Use the parsed number
//             sx={{
//               height: 8,
//               borderRadius: 5,
//               backgroundColor: "#374151",
//               "& .MuiLinearProgress-bar": {
//                 backgroundColor: usagePercentage >= 90 ? "#EF4444" : "#4F46E5",
//               },
//             }}
//           />
//           {/* Usage Text */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               marginTop: "8px",
//               fontSize: "12px",
//               color: "#D1D5DB",
//             }}
//           >
//             {/* 💡 FIX: Use the data_used_gb and data_limit_gb strings */}
//             <span>{usagePercentage.toFixed(2)}% Used</span>
//             <span>
//               {dataUsedGB} GB / {dataLimitGB} GB
//             </span>
//           </div>
//           {/* Upgrade Button */}
//           {usagePercentage >= 90 && (
//             <Link
//               to="/dashboard/Pricing"
//               style={{ textDecoration: "none", display: "block" }}
//             >
//               <div
//                 style={{
//                   marginTop: "12px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "#EA6A12",
//                   color: "#fff",
//                   padding: "8px",
//                   borderRadius: "6px",
//                   fontSize: "14px",
//                   fontWeight: 600,
//                   cursor: "pointer",
//                   transition: "background-color 0.2s",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.backgroundColor = "#c7570f")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.backgroundColor = "#EA6A12")
//                 }
//               >
//                 <GiSpades size={16} style={{ marginRight: "6px" }} />
//                 Increase Storage (Premium)
//               </div>
//             </Link>
//           )}
//         </>
//       ) : (
//         <span style={{ color: "#D1D5DB" }}>Loading storage data...</span>
//       )}
//     </Box>
//   );

//   return (
//     <Tooltip
//       title={tooltipContent}
//       placement="bottom-end"
//       arrow
//       onOpen={fetchStorageStats}
//       enterDelay={100}
//       leaveDelay={100}
//       slotProps={{
//         popper: {
//           sx: {
//             "& .MuiTooltip-tooltip": {
//               backgroundColor: "#1F2937",
//               border: "1px solid #4B5563",
//               maxWidth: 300,
//             },
//             "& .MuiTooltip-arrow": {
//               color: "#1F2937",
//             },
//           },
//         },
//       }}
//     >
//       <IconButton style={{ color: "#A6AAAD", marginLeft: "20px" }}>
//         <FaHdd style={{ fontSize: "24px" }} />
//         {/* Visual indicator of usage */}
//         {storageStats && usagePercentage > 0 && (
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: 4,
//               left: "50%",
//               transform: "translateX(-50%)",
//               width: "50%",
//               height: "2px",
//               backgroundColor: usagePercentage >= 90 ? "#EF4444" : "#4F46E5",
//             }}
//           />
//         )}
//       </IconButton>
//     </Tooltip>
//   );
// };

// export default StorageIcon;
// src/components/StorageIcon.js

import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  IconButton,
  Tooltip,
  Box,
  LinearProgress,
  useMediaQuery,
} from "@mui/material";
import { FaHdd } from "react-icons/fa";
import { GiSpades } from "react-icons/gi";
import config from "../config";

const baseUrl = config.baseURL;

const StorageIcon = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  /**
   * storageState:
   * "idle"    → not requested yet
   * "loading" → fetching
   * "error"   → failed / timeout
   * object    → API data
   */
  const [storageState, setStorageState] = useState("idle");

  const fetchStorageStats = useCallback(async () => {
    if (storageState !== "idle") return;

    const token = localStorage.getItem("token");
    if (!token) return;

    setStorageState("loading");

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(`${baseUrl}/api/storage`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      });
      console.log("Storage API response:", response);
      if (!response.ok) throw new Error("Failed");

      const data = await response.json();
      console.log("Storage API data:", data);
      setStorageState(data);
    } catch {
      setStorageState("error");
    } finally {
      clearTimeout(timeoutId);
    }
  }, [storageState]);

  if (isMobile) return null;

  const isData = typeof storageState === "object";

  const usagePercentage = isData
    ? Number(storageState.usage_percentage || 0)
    : 0;

  const dataUsed = isData ? storageState.data_used : "0 B";
  const dataLimit = isData ? storageState.data_limit : "0 B";

  const tooltipContent = (
    <Box sx={{ padding: 1, minWidth: 250 }}>
      <h4 style={{ margin: "0 0 10px", color: "#F9FAFB", fontSize: 14 }}>
        Storage Usage
      </h4>

      {storageState === "loading" && (
        <span style={{ color: "#D1D5DB", fontSize: 12 }}>Loading storage…</span>
      )}

      {storageState === "error" && (
        <span style={{ color: "#9CA3AF", fontSize: 12 }}>
          Storage info unavailable
        </span>
      )}

      {isData && (
        <>
          <LinearProgress
            variant="determinate"
            value={usagePercentage}
            sx={{
              height: 8,
              borderRadius: 5,
              backgroundColor: "#374151",
              "& .MuiLinearProgress-bar": {
                backgroundColor: usagePercentage >= 90 ? "#EF4444" : "#4F46E5",
              },
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 8,
              fontSize: 12,
              color: "#D1D5DB",
            }}
          >
            <span>{usagePercentage}% Used</span>
            <span>
              {dataUsed} / {dataLimit}
            </span>
          </div>

          {usagePercentage >= 90 && (
            <Link
              to="/dashboard/Pricing"
              style={{ textDecoration: "none", display: "block" }}
            >
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#EA6A12",
                  color: "#fff",
                  padding: 8,
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                <GiSpades size={16} style={{ marginRight: 6 }} />
                Increase Storage (Premium)
              </div>
            </Link>
          )}
        </>
      )}
    </Box>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="bottom-end"
      arrow
      enterDelay={100}
      onOpen={fetchStorageStats}
      slotProps={{
        popper: {
          sx: {
            "& .MuiTooltip-tooltip": {
              backgroundColor: "#1F2937",
              border: "1px solid #4B5563",
              maxWidth: 300,
            },
            "& .MuiTooltip-arrow": {
              color: "#1F2937",
            },
          },
        },
      }}
    >
      <IconButton style={{ color: "#A6AAAD", marginLeft: 20 }}>
        <FaHdd style={{ fontSize: 24 }} />

        {isData && usagePercentage > 0 && (
          <Box
            sx={{
              position: "absolute",
              bottom: 4,
              left: "50%",
              transform: "translateX(-50%)",
              width: "50%",
              height: 2,
              backgroundColor: usagePercentage >= 90 ? "#EF4444" : "#4F46E5",
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default StorageIcon;
